import Header from '../components/header/Header'
import Sidebar from '../components/sidebar/Sidebar'
import { useState } from 'react'
import './layout.scss'
import { useLocation } from 'react-router-dom'
import { ClickAwayListener } from '@mui/material'
import useScreenSize from '../hooks/useScreenSize'

const Layout = ({ children }) => {
  const location = useLocation();
  const pathname = location.pathname;

  const [open, setOpen] = useState(true)
  const screenSize = useScreenSize()

  return (
    <>
      {pathname && pathname == '/student-exam-test' || pathname == '/student-practice'? <div className='main-layout flex'>
        <div className='no-sidebar-cont'>
          <Header />
          {children}
        </div>
      </div>: <div className='main-layout flex'>
        <ClickAwayListener  onClickAway={()=>{
          open == true && screenSize == "tab" && setOpen(false)
        }}>
        <div className='sidebar-container'>
          <Sidebar open={open} setOpen={setOpen} />
        </div>
        </ClickAwayListener>
        <div className={`header-view-container ${open ? 'header-view-container-toggle' : ''}`}>
          <Header />
          {children}
        </div>
      </div>}
    
    </>
  )
}

export default Layout
